import React, { useState, useEffect } from "react";
import * as api from "../api/api";
import TeamInfo from "../Components/TeamInfo";
import Loading from "../Components/Loading";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
import startAdding from "../../src/images/startAdding.svg";

function AdminTeamAdminstration(props) {
  const { language } = useLanguage();
  const pageTitle = "AdminTeamAdminstration";
  const [teamList, setTeamList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  const navigate = useNavigate();

  // GET All TEAMS
  const fetchTeams = () => {
    api
      .getAllTeams()
      .then((response) => {
        setTeamList(response.data.object);
        setLoading(false);
      })
      .catch((error) => {
        // TODO: Handle error
      });
  };
  // Add a new Team field to the team list
  const addTeam = () => {
    const newTeam = { teamId: "", name: "" };
    setTeamList([...teamList, newTeam]);
    setIsDisabled(true); // Disable add new team till process is finished
  };
  // Delete a Team
  const handleRemoveTeam = (_id) => {
    setTeamList(teamList.filter((team) => (team.teamId !== _id ? team : "")));
    setIsDisabled(false);
  };
  // handleAddButtonBehavior
  const handleAddButtonBehavior = (state) => {
    setIsDisabled(state);
  };

  const handleTeamInfoChange = (updatedTeamInfo) => {
    // Find the index of the team in the list
    const updatedTeamIndex = teamList.findIndex((team) => team.teamId == "");

    // Update the teamList with the modified team information
    const updatedTeamList = [...teamList];
    updatedTeamList[updatedTeamIndex] = updatedTeamInfo;

    // Update the state with the new teamList
    setTeamList(updatedTeamList);
  };

  // Initial Render
  useEffect(() => {
    checkAuthorization("TEAM_ADMINSTRATION").then((result) => {
      if (result) {
        fetchTeams();
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);
  return (
    <div className="main-content">
      {isLoading && <Loading />}
      <p className="main-content__title">
        {strings[pageTitle][language].pageName}
      </p>
      <hr className="main-content-title__hr" />

      <div className="team-list">
        {teamList.length > 0 ? (
          teamList.map((team) => (
            <TeamInfo
              key={team.teamId}
              team={team}
              handleRemoveTeam={handleRemoveTeam}
              addTeamButton={handleAddButtonBehavior}
              onTeamInfoChange={handleTeamInfoChange} // Pass the callback function
            />
          ))
        ) : (
          <div className="d-flex gap-3 flex-column justify-content-center align-items-center">
            <img src={startAdding} alt="start adding" />
            <h5 className="mt-auto p-2 bd-highlight">
              {strings[pageTitle][language].empty}
            </h5>
          </div>
        )}
      </div>

      <div style={{ borderBottom: "1px solid black", margin: "1em" }}></div>
      <button
        // TODO: Change button style when disabled
        className={isDisabled ? "button-round .disabled" : "button-round"}
        style={{ alignSelf: "flex-end", margin: "1em" }}
        onClick={addTeam}
        disabled={isDisabled}
      >
        {strings[pageTitle][language].add}
      </button>
    </div>
  );
}

export default AdminTeamAdminstration;
